import { isNative } from './platform';

// Open an external (off-origin) URL the right way on each platform.
//
// THE BUG THIS SOLVES (native Android): a plain window.open(url, '_blank') or an
// <a target="_blank"> navigates the in-app WebView to the external URL. For App-Link
// targets (e.g. app.asana.com) Android hands the URL to the installed app; on return the
// WebView is *still* parked on that external URL, so it immediately re-fires the App Link —
// an inescapable loop with no way back to CBAM.
//
// THE FIX: on native, open external URLs in a system Custom Tab / SFSafariViewController via
// @capacitor/browser (the same idiom ProfileSheet already uses for desktop deep-links). That
// runs *outside* our WebView, keeps the CBAM activity on the back stack, and returns the user
// straight back to the app. On web there is no WebView to trap, so we keep the classic
// new-tab behaviour byte-for-byte.
//
// Belt-and-braces: dynamic-import @capacitor/browser so the web bundle never eagerly pulls the
// native plugin, and wrap everything in try/catch — opening a link must never throw.
export async function openExternal(url: string): Promise<void> {
  try {
    if (isNative()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    }
  } catch {
    // Native open failed (plugin missing / bridge error): fall through to the web behaviour
    // rather than leave the tap dead.
  }
  try {
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch {
    /* opening a link must never throw */
  }
}
